import React from 'react';

import { Stack, Inline, xcss } from '@atlaskit/primitives';

import { AiSubFooter } from './AiSubFooter';
import { BulkCreateButtonGroup } from './BulkCreateButtonGroup';
import { IssueCreateAiFeedback } from './IssueCreateAiFeedback';

const footerBaseStyles = xcss({
	backgroundColor: 'elevation.surface',
	borderTopColor: 'color.border',
	borderTopStyle: 'solid',
	borderTopWidth: 'border.width',
	boxShadow: 'elevation.shadow.overflow',
	flexShrink: 0,
});

const footerTopStyles = xcss({
	paddingTop: 'space.150',
	paddingBottom: 'space.150',
	paddingLeft: 'space.200',
	paddingRight: 'space.200',
});

// Need to figure out which contentId we want to use here - either same one for single create feedback or different one for bulk
const contentId = 'contentId';

export const BulkCreateFooter = ({ onClose }: { onClose: () => void }) => {
	return (
		<Stack xcss={footerBaseStyles}>
			<Inline alignInline="center" grow="fill" spread="space-between" xcss={footerTopStyles}>
				<IssueCreateAiFeedback contentId={contentId} />
				<BulkCreateButtonGroup onClose={onClose} />
			</Inline>
			<AiSubFooter />
		</Stack>
	);
};
